import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, ErrorMessage } from "formik";
import { useStyles } from "../styles";
import * as Yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { __esModule } from "redux-persist/lib/storage";
import useArrival from "../../../../Hooks/arrival";
import Loader from "../../../../common/Loader";
import { useEffect } from "react";

const UpdateArrivals = () => {
  const classes = useStyles();
  const { updateArrivalInfo, loading, redirect } = useArrival();

  const navigate = useNavigate();
  const location = useLocation();
  const date = new Date(location.state.arrivalDate);

  const minDate = new Date("01/01/1950");

  const initValues = {
    title: location.state.title,
    author: location.state.author,
    arrivalDate: date,
    id: location.state.id,
  };

  const updatearrivalListSchema = Yup.object().shape({
    title: Yup.string().required("* Please enter book title name"),
    author: Yup.string().required("* Please enter author name"),
    arrivalDate: Yup.date()
      .min(minDate, "* Invalid ate selected")
      .required("* Please selct date"),
  });

  useEffect(() => {
    if (redirect) {
      navigate("/arrivals");
    }
  }, [redirect]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Stack className={classes.arrival}>
          <Grid container>
            <Grid item lg={8} sm={12}>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    p: 4,
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Typography
                    sx={{ py: 2 }}
                    className={classes.add_course_text}
                  >
                    Update Arrivals
                  </Typography>
                  <Grid item lg={8} sm={12}>
                    <Stack>
                      <Formik
                        validationSchema={updatearrivalListSchema}
                        initialValues={initValues}
                        validateOnBlur={false}
                        validateOnChange={false}
                        onSubmit={(values) => {
                          updateArrivalInfo(values);
                        }}
                      >
                        {(formik) => {
                          const {
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            values,
                          } = formik;
                          return (
                            <form onSubmit={handleSubmit}>
                              <Grid
                                container
                                sx={{ py: 2 }}
                                className={classes.form_add_course}
                                spacing={4}
                              >
                                <Grid item md={9}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 2 }}
                                      >
                                        Book Title
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="title"
                                        name="title"
                                        placeholder="Enter title"
                                        className={
                                          errors.title && touched.title
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.title}
                                      />
                                      <ErrorMessage
                                        name="title"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                </Grid>
                                <Grid item md={3}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 2 }}
                                      >
                                        Date
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="arrivalDate"
                                        type="date"
                                        name="arrivalDate"
                                        onChange={handleChange}
                                        defaultValue={
                                          date.toISOString().split("T")[0]
                                        }
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        placeholder="Update arrival Date"
                                      />
                                      <ErrorMessage
                                        name="arrivalDate"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                sx={{ pb: 2 }}
                                className={classes.form_add_course}
                                spacing={4}
                              >
                                <Grid item md={9}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 1 }}
                                      >
                                        Author
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="author"
                                        name="author"
                                        placeholder="Update Author"
                                        className={
                                          errors.author && touched.author
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.author}
                                      />
                                      <ErrorMessage
                                        name="author"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                </Grid>
                                <Grid item md={3}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      mt: 2,
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 3, ml: 1 }}
                                      >
                                        <Button
                                          onClick={() => navigate("/arrivals")}
                                          sx={{
                                            borderRadius: "50px",
                                            width: "120px",
                                          }}
                                          className={classes.cancel_arrival}
                                        >
                                          Cancel
                                        </Button>
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <Button
                                        type="submit"
                                        sx={{
                                          borderRadius: "50px",
                                          width: "120px",
                                        }}
                                        className={classes.add_arrival}
                                      >
                                        {/* Update Arrivals */}
                                        Update
                                      </Button>
                                    </Stack>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </form>
                          );
                        }}
                      </Formik>
                    </Stack>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      )}
    </>
  );
};

export default UpdateArrivals;
